import { Injectable } from '@angular/core';

import { parseToNumber } from '../shared/funcs/parser-helpers';

@Injectable({
  providedIn: 'root'
})
export class BidCutRequestCalculationService {
  calculateCutAmount(currentBidValue: number, lotCutPercentage: number): number {
    if (currentBidValue <= 0 || lotCutPercentage <= 0) {
      return 0;
    }
    return currentBidValue - ((currentBidValue * lotCutPercentage) / 100);
  }

  calculateNewBidValue(currentBidValue: number, cutAmount: number): number {
    const parsedCutAmount = parseToNumber(cutAmount);
    const parsedCurrentBid = parseToNumber(currentBidValue);
    return Math.max(0, parsedCurrentBid - parsedCutAmount);
  }

  parseBidValue(bid: string | number | undefined | null): number {
    return parseToNumber(bid);
  }

  calculateCutPercentageAmount(
    currentBidValue: number,
    lotCutPercentage: number,
    requiresDecimal: boolean = true
  ): number {
    if (currentBidValue <= 0 || lotCutPercentage <= 0) {
      return 0;
    }
    const raw = (currentBidValue * lotCutPercentage) / 100;
    if (requiresDecimal) {
      return Math.round(raw * 100) / 100;
    }
    return Math.round(raw);
  }
}

